import { render, staticRenderFns } from "./SectionActionsRemove.vue?vue&type=template&id=70a4a798&lang=pug&"
import script from "./SectionActionsRemove.vue?vue&type=script&lang=js&"
export * from "./SectionActionsRemove.vue?vue&type=script&lang=js&"
import style0 from "./SectionActionsRemove.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports